<template>
    <div class="exemption-list">
        <heading :title="title" tag="exemption-list-title"/>
        <div class="responsive">
            <data-table ref="dataTable"
                        persist-name="exemption-filter"
                        :show-filters="true"
                        :show-pager="true"
                        :get-items="getEntries"
                        v-model="filters"
                        :fields="fields">
                <!-- template for custom columns -->
                <template v-slot:customField="slotProps">
                    <div v-if="slotProps.row.field.key === 'id'">
                        {{ slotProps.row.item.id }}
                    </div>
                    <div v-if="slotProps.row.field.key === 'company'">
                        {{ slotProps.row.item.equipment.company.name }}
                    </div>
                    <div v-if="slotProps.row.field.key === 'vehicle_id'">
                        {{ slotProps.row.item.equipment.vehicle_id }}
                    </div>
                    <div v-if="slotProps.row.field.key === 'status'">
                        <exemption-status-badge :status="slotProps.row.item.status"
                                                :granted-thru="slotProps.row.item.granted_thru"/>
                    </div>
                    <div v-if="slotProps.row.field.key === 'type'">
                        {{ slotProps.row.item.type }}
                    </div>
                    <div v-if="slotProps.row.field.key === 'project.name'">
                        {{ slotProps.row.item.project ? slotProps.row.item.project.name : '' }}
                    </div>
                    <div v-if="slotProps.row.field.key === 'expiration'">
                        <timestamp :include-time="false"
                                   :include-year="true"
                                   :date="slotProps.row.item.expiration"/>
                    </div>
                    <div v-if="slotProps.row.field.key === 'actions'">
                        <auth-template model="exemption" action="approve" :arg="slotProps.row.item.id">
                            <router-link class="btn btn-sm btn-secondary mr-2 btn-icon"
                                         :to="`/exemption/view/${slotProps.row.item.id}`">
                                <b-icon-eye/>
                            </router-link>
                        </auth-template>
                    </div>
                </template>
            </data-table>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import Api from '@/providers/Api'
import Exemption from '@/models/Exemption'

export default Vue.extend({
    name: 'ExemptionList',
    data () {
        return {
            types: [],
            exemptionFields: Exemption,
            fields: [
                { key: 'id', sortable: true, label: 'ID' },
                { key: 'company', sortable: true, label: 'Company' },
                { key: 'vehicle_id', sortable: true, label: 'ID/Name' },
                { key: 'company', sortable: true, label: 'Company' },
                { key: 'status', sortable: true, label: 'Status' },
                { key: 'type', sortable: true, label: 'Type' },
                { key: 'project.name', sortable: true, label: 'Project' },
                { key: 'expiration', sortable: true, label: 'Expiration' },
                { key: 'actions', sortable: false },
            ],
            filters: {
                status: {
                    field: 'status',
                    label: 'Status',
                    type: 'select',
                    options: Exemption.allStatusOptions,
                },
                company_id: {
                    field: 'company_id',
                    type: 'multiselect',
                    search: (query) => {
                        return Api.getItems(this, 'company', { name: { field: 'name', value: query } })
                    },
                    apiTable: 'company',
                    labelField: 'name',
                    value: null,
                    label: 'Company'
                },
            },

            title: 'Exemption Requests',
        }
    },
    methods: {
        getEntries (listParams) {
            return this.$api.getItems(this, 'exemption', this.filters, listParams, ['equipment', 'project'])
        },
        getStatusOptionLabel (value) {
            return Exemption.getStatusLabel(value)
        },
        getStatusBadgeVariant (value) {
            return Exemption.getStatusBadgeVariant(value)
        },
    },
})
</script>
